/**
 * Nützliche Hilfsfunktionen.
 *
 * @author Andreas Wenger
 */

/**
  * True, gdw. wenn mindestens eine Property (außer Funktionen) des
  * gegebenen Objekts gesetzt ist.
  * Gesetzt heißt: nicht undefined, und nicht "".
  */
export function isAnyPropertySet(o: Object) : boolean {
  for (var key in o)
    if (o[key] !== undefined && typeof o[key] !== 'function' && o[key] !== '')
      return true;
  return false;
}



// WEBPACK FOOTER //
// ./src/util/util.ts